// extracted by mini-css-extract-plugin
module.exports = {"base":"fiveStories1AdWithTagSearch-m__base__32qeE","wrapper":"fiveStories1AdWithTagSearch-m__wrapper__2A21F"};